import isEmpty from 'lodash/isEmpty'
import React, { FC } from 'react'

import { Chip, ChipProps } from '@Components/Chips/Chip/Chip'
import { useTranslation } from '@Globals/Translations'

interface DiscountProps extends ChipProps {
  discount: {
    context?: string
    percentage?: number
  }
}

export const getColor = (type: string) => {
  const lowerType = type.toLowerCase()
  switch (type) {
    case 'black_friday':
    case 'black_week':
    case 'cyber_monday':
      return 'black'
    case 'outlet':
      return 'red'

    default:
      if (lowerType.includes('clover')) {
        return 'clover'
      }
      if (lowerType.includes('magma')) {
        return 'magma'
      }
      if (lowerType.includes('newclassics')) {
        return 'newclassics'
      }
      if (lowerType.includes('end_season_sale_large')) {
        return 'end_season_sale_large'
      }
      if (lowerType.includes('end_season_sale_small') || lowerType.includes('end_season_sale')) {
        return 'end_season_sale_small'
      }
      if (lowerType.includes('summer_sale_large')) {
        return 'summer_sale_large'
      }
      if (lowerType.includes('summer_sale_small') || lowerType.includes('summer_sale')) {
        return 'summer_sale_small'
      }
      if (lowerType.includes('valentine_a_large')) {
        return 'valentine_a_large'
      }
      if (lowerType.includes('valentine_a_small') || lowerType.includes('valentine_a')) {
        return 'valentine_a_small'
      }
      if (lowerType.includes('valentine_b_large')) {
        return 'valentine_b_large'
      }
      if (lowerType.includes('valentine_b_small') || lowerType.includes('valentine_b')) {
        return 'valentine_b_small'
      }
      if (lowerType.includes('blacksale')) {
        return 'blacksale'
      }
      if (lowerType.includes('trendhimclubexclusive')) {
        return 'trendhimclubexclusive'
      }
      if (lowerType.includes('lateseasonsalesvg')) {
        return 'lateseasonsalesvg'
      }
      if (lowerType.includes('lateseasonsale')) {
        return 'lateseasonsale'
      }
      if (lowerType.includes('sale')) {
        return 'sale'
      }
      return isEmpty(type) ? 'red' : type
  }
}

const legacyWordbook = (context: string) => {
  switch (context) {
    case 'bundle_offer':
      return 'common:BUNDLE_OFFER_PRODUCT_TAG'
    case 'outlet':
      return 'outlet'
    default:
      return ''
  }
}

const LegacyDiscountChip: FC<DiscountProps> = ({
  discount,
  size = 'medium',
}) => {
  const { t } = useTranslation()
  const {
    context = '',
    percentage = 0,
  } = discount

  const label = t(legacyWordbook(context))

  if (!label) {
    return null
  }

  const color = getColor(context)
  const isDiscount = (percentage || 0) > 0
  const percentageLabel = isDiscount ? `-${percentage}%` : ''
  const separator = label !== '' && isDiscount ? ' ' : ''

  return (
    <Chip color={color} size={size}>
      {color === 'red' ? `${label}${separator}${percentageLabel}` : `${percentageLabel}${separator}${label}`}
    </Chip>
  )
}

export const DiscountChip: FC<DiscountProps> = ({
  discount,
  size = 'medium',
}) => {
  const { t } = useTranslation()

  const {
    context = '',
    percentage = 0,
  } = discount
  const label = t('common:discount_chip', {
    context,
    discountPercentage: percentage,
  })
  const color = getColor(context)
  if (label === 'discount_chip') {
    return <LegacyDiscountChip discount={discount} size={size} />
  }

  if (!label) {
    return null
  }

  return (
    <Chip color={color} size={size}>
      {label}
    </Chip>
  )
}

